import useSWR from 'swr'
import { ScheduleType } from '../common/types/calendar'
import { useCalendarContext } from '../context/calendar'
import { convertSchedules, Row } from '../options/convertSchedules'
import fetchSchedules from '../options/fetchSchedules'
import getConditions from '../options/getConditions'
import { useAuth } from '../../hooks/use-auth'

type Response = {
  isError: boolean
  isLoading: boolean
  schedules: ScheduleType[] | undefined
}

const useSchedules = (): Response => {
  const auth = useAuth()
  const { date, filtered } = useCalendarContext()
  const { data, error } = useSWR<Row[] | undefined>(['/api/schedules', date, filtered], () =>
    fetchSchedules(auth.authorizationHeader, auth.factoryId, getConditions(date, filtered))
  )
  const schedules = convertSchedules(data || [])

  return {
    isError: !!error,
    isLoading: !error && !data,
    schedules: schedules,
  }
}

export default useSchedules
